
    import { Component, Vue, Prop, Watch } from "vue-property-decorator";
    @Component({})
    export default class ErrorNotification extends Vue {
        @Prop()
        errorMsg: any;
        @Prop()
        errorType: any;
    }

